import React from "react";

const StudentBars = ({ values }) => {
  const maxValue = Math.max(...values);

  return (
    <div className="mt-4 flex h-[110px] items-end gap-4">
      {values.map((value, index) => {
        const heightPercent = (value / maxValue) * 100;

        return (
          <div
            key={`${value}-${index}`}
            className="w-9 rounded-t-[4px] bg-[#B07EB0]"
            style={{ height: `${heightPercent}%` }}
            aria-label={`student-metric-bar-${index + 1}`}
          />
        );
      })}
    </div>
  );
};

export default StudentBars;
